import moment from "moment";

export const STATUS = {
  AGENDADO: "AGENDADO",
  ATIVO: "ATIVO",
  ENCERRADO: "ENCERRADO",
};

export const STATUS_CONFIG = {
  [STATUS.AGENDADO]: {
    label: "Agendado",
    color: "warning",
    badgeColor: "#f37b1d",
  },
  [STATUS.ATIVO]: {
    label: "Ativo",
    color: "success",
    badgeColor: "#5eb95e",
  },
  [STATUS.ENCERRADO]: {
    label: "Encerrado",
    color: "secondary",
    badgeColor: "#666",
  },
};

/**
 * Banner sem data é sempre vigente — o backend usa a mesma regra
 * (COALESCE com a data de hoje) ao filtrar a listagem por status.
 */
export function computeStatus(banner) {
  const hoje = moment().startOf("day");

  if (banner.data_inicio && moment(banner.data_inicio).startOf("day").isAfter(hoje)) {
    return STATUS.AGENDADO;
  }

  if (banner.data_fim && moment(banner.data_fim).startOf("day").isBefore(hoje)) {
    return STATUS.ENCERRADO;
  }

  return STATUS.ATIVO;
}

export function getStatusConfig(banner) {
  const status = computeStatus(banner);
  return { status, ...STATUS_CONFIG[status] };
}
